import React, { useEffect, useState } from 'react';
import '../ResourcesPage.css';

const ResourcesPage = () => {
  const [resources, setResources] = useState([]);
  const [positions, setPositions] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [editStates, setEditStates] = useState({});
  const [expanded, setExpanded] = useState({});
  const [newResource, setNewResource] = useState({
    first_name: '', last_name: '', email: '', start_date: '', hourly_rate: '',
    position_id: '', organization_id: ''
  });

 useEffect(() => {
  fetchResources();

  fetch('/positions')
    .then(res => res.ok ? res.json() : Promise.reject('Positions fetch failed'))
    .then(setPositions)
    .catch(console.error);

  fetch('/organizations')
    .then(res => res.ok ? res.json() : Promise.reject('Organizations fetch failed'))
    .then(setOrganizations)
    .catch(console.error);
}, []);


const fetchResources = () => {
  fetch('/resources')
    .then(res => res.ok ? res.json() : Promise.reject('Resources fetch failed'))
    .then(data => {
      setResources(data);
      const state = {}, expandState = {};
      data.forEach(r => {
        state[r.id] = { isEditing: false, values: { ...r } };
        expandState[r.id] = false;
      });
      setEditStates(state);
      setExpanded(expandState);
    })
    .catch(console.error);
};


  const handleChange = (id, key, value) => {
    setEditStates(prev => ({
      ...prev,
      [id]: {
        ...prev[id],
        values: { ...prev[id].values, [key]: value }
      }
    }));
  };

  const handleNestedChange = (id, key, idx, field, value) => {
    const arr = [...editStates[id].values[key]];
    arr[idx][field] = value;
    handleChange(id, key, arr);
  };

  const toggleEdit = id => {
    setEditStates(prev => ({
      ...prev,
      [id]: {
        isEditing: !prev[id].isEditing,
        values: { ...resources.find(r => r.id === id) }
      }
    }));
  };

  const toggleExpand = id => {
    setExpanded(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const handleCancel = id => toggleEdit(id);

const handleSave = async id => {
  const rawValues = editStates[id].values;

  const updated = {
    ...rawValues,
    position_id: rawValues.position_id ? Number(rawValues.position_id) : null,
    organization_id: rawValues.organization_id ? Number(rawValues.organization_id) : null
  };

  try {
    const res = await fetch(`/resources/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updated)
    });
    if (res.ok) {
      fetchResources();
      toggleEdit(id);
    }
  } catch (e) {
    console.error(e);
  }
};


  const handleNewChange = (key, value) => {
    setNewResource(prev => ({ ...prev, [key]: value }));
  };

  const handleAddNew = async () => {
    try {
      const res = await fetch('/resources', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newResource)
      });
      if (res.ok) {
        setNewResource({
          first_name: '', last_name: '', email: '', start_date: '', hourly_rate: '',
          position_id: '', organization_id: ''
        });
        fetchResources();
      }
    } catch (err) {
      console.error('Error adding resource:', err);
    }
  };

  const sections = [
    { label: 'Billing Cycles', key: 'billing_cycles', fields: ['start_date', 'end_date', 'issue_date', 'due_date', 'amount_due'], dateFields: ['start_date','end_date','issue_date','due_date'] },
    { label: 'Performance Notes', key: 'performance_notes', fields: ['category', 'note', 'note_date'], dateFields: ['note_date'] },
    { label: 'Planned Time Off', key: 'planned_time_off', fields: ['start_date', 'end_date', 'reason'], dateFields: ['start_date','end_date'] },
    { label: 'Reviews', key: 'reviews', fields: ['review_start','review_end','review_text','auto_flagged_issues','status_name'], dateFields: ['review_start','review_end'] },
    { label: 'Work Logs', key: 'work_logs', fields: ['work_date','start_time','end_time','total_hours','week_number','year'], dateFields: ['work_date'] },
  ];

  return (
    <div className="resources-container">
      <h1>Resource Management</h1>

      {/* Add New Resource */}
      <div className="add-new-form">
        
        
        
        <h3>Add New Resource</h3>

        <div>
        {['first_name', 'last_name', 'email', 'start_date', 'hourly_rate'].map(field => (
          <input
            key={field}
            placeholder={field.replace('_', ' ')}
            type={field.includes('date') ? 'date' : 'text'}
            value={newResource[field]}
            onChange={e => handleNewChange(field, e.target.value)}
          />
        ))}
        </div>
        
        <div>
        <select value={newResource.position_id} onChange={e => handleNewChange('position_id', e.target.value)}>
          <option value="">-- Select Position --</option>
          {positions.map(p => <option key={p.id} value={p.id}>{p.title}</option>)}
        </select>
        <select value={newResource.organization_id} onChange={e => handleNewChange('organization_id', e.target.value)}>
          <option value="">-- Select Organization --</option>
          {organizations.map(o => <option key={o.id} value={o.id}>{o.name}</option>)}
        </select>
        <button onClick={handleAddNew}>➕ Add</button>
        </div>


      </div>

      {/* Resource Cards */}
      <div className="resources-grid">
        {resources.map(r => {
          const edit = editStates[r.id];
          if (!edit) return null;
          const vals = edit.values;
          const isEditing = edit.isEditing;
          const isExpanded = expanded[r.id];

          return (
            <div className="resource-card" key={r.id}>
              <h2><strong>{vals.first_name} {vals.last_name}</strong></h2>

              {/* Summary Info */}
              {['email','start_date','hourly_rate'].map(key => (
                <div key={key}>
                  <strong>{key.replace('_', ' ')}:</strong>{' '}
                  {isEditing ? (
                    <input
                      type={key.includes('date') ? 'date' : 'text'}
                      value={vals[key] || ''}
                      onChange={e => handleChange(r.id, key, e.target.value)}
                    />
                  ) : (
                    <span>{vals[key]}</span>
                  )}
                </div>
              ))}

              {/* Dropdowns */}
              <div>
                <strong>Position:</strong>{' '}
                {isEditing ? (
                  <select value={vals.position_id || ''} onChange={e => handleChange(r.id, 'position_id', e.target.value)}>
                    <option value="">-- Select --</option>
                    {positions.map(p => <option key={p.id} value={p.id}>{p.title}</option>)}
                  </select>
                ) : (
                  vals.position
                )}
              </div>
              <div>
                <strong>Organization:</strong>{' '}
                {isEditing ? (
                  <select value={vals.organization_id || ''} onChange={e => handleChange(r.id, 'organization_id', e.target.value)}>
                    <option value="">-- Select --</option>
                    {organizations.map(o => <option key={o.id} value={o.id}>{o.name}</option>)}
                  </select>
                ) : (
                  vals.organization
                )}
              </div>

              <button onClick={() => toggleExpand(r.id)}>
                {isExpanded ? '⬆ Hide Details' : '⬇ Show Details'}
              </button>

              {isExpanded && (
                <div className="expanded-section">
                  {sections.map(sec => (
                    <div key={sec.key} className="nested-section">
                      <h4>{sec.label}</h4>
                      {vals[sec.key]?.map((entry, idx) => (
                        <div key={idx} className="nested-entry">
                          {sec.fields.map(field => {
                            const isDate = sec.dateFields.includes(field);
                            return isEditing ? (
                              <input
                                key={field}
                                type={isDate ? 'date' : 'text'}
                                value={isDate ? entry[field]?.split('T')[0] || '' : entry[field] || ''}
                                onChange={e => handleNestedChange(r.id, sec.key, idx, field, e.target.value)}
                                placeholder={field}
                              />
                            ) : (
                              <div key={field}>
                                <strong>{field.replace('_', ' ')}</strong>: {entry[field]}
                              </div>
                            );
                          })}
                        </div>
                      ))}
                      {(!vals[sec.key]?.length) && <p>No entries</p>}
                    </div>
                  ))}
                </div>
              )}

              {/* Action Buttons */}
              {isEditing ? (
                <div className="btn-group">
                  <button onClick={() => handleSave(r.id)}>💾 Save</button>
                  <button onClick={() => handleCancel(r.id)}>✖ Cancel</button>
                </div>
              ) : (
                <button onClick={() => toggleEdit(r.id)}>✏️ Edit</button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ResourcesPage;
